"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconCalendar = function IconCalendar(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    className: (0, _classnames.default)('Icon', 'IconCalendar', className),
    style: style
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M10.8 0c.387 0 .7.326.7.727v.727h1.4c1.16 0 2.1.977 2.1 2.182v10.182C15 15.023 14.06 16 12.9 16H3.1C1.94 16 1 15.023 1 13.818V3.636c0-1.205.94-2.181 2.1-2.181l1.4-.001V.727c0-.368.263-.672.605-.72L5.2 0c.387 0 .7.326.7.727l-.001.727H10.1V.727c0-.368.263-.672.605-.72zm2.8 7.272H2.4v6.546c0 .402.313.727.7.727h9.8c.387 0 .7-.325.7-.727V7.272zM4.5 2.909H3.1c-.387 0-.7.326-.7.727v2.182h11.2V3.636a.714.714 0 0 0-.7-.727h-1.4v.727a.719.719 0 0 1-.605.721l-.095.007a.714.714 0 0 1-.7-.728V2.91H5.899l.001.727a.719.719 0 0 1-.605.721l-.095.007a.714.714 0 0 1-.7-.728V2.91z"
  }));
};

var _default = IconCalendar;
exports.default = _default;